export enum WAFExecutionModeEnum {
  Logging,
  Blocking,
}
